import React from 'react'

import { SvgExclamationMark } from '@chilipiper/icons/src/design-system/ExclamationMark'

import { Alert, CustomAlertProps } from './Alert'

export const ErrorAlert = (props: CustomAlertProps) => {
  return <Alert icon={SvgExclamationMark} iconColor='fg/caution' px={5} {...props} />
}
